import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightComponentOrderRequest from "../../Orders/OrderRequest/RightComponentOrderRequest";
import EventPaymentMain from "./EventPaymentLeft";
import RightComponentEventPayment from "./RightComponentEventPayment";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { get_single_rsvp_event_information } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

const EventPayment = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [eventId, setEventId] = useState();
  const [ticketFormData, setTicketFormData] = useState();
  const [getSingleEventInfo, setGetSingleEventInfo] = useState({});
  const [price, setPrice] = useState({ adult: false, child: false });

  useEffect(() => {
    setEventId(location.state.addGuestInfo);
    setPrice(location.state.price);
    setTicketFormData(location.state.formData);
    props.get_single_rsvp_event_information(
      location.state.addGuestInfo,
      props.auth.user.accessToken
    );
  }, [location]);

  useEffect(() => {
    setGetSingleEventInfo(props.getSingleEventInfo);
  }, [props.getSingleEventInfo]);

  const onBackButtonClick = (e) => {
    history.push({
      pathname: `/offline-events/add-guest-event/${eventId}`,
      state: {
        offlineEventInformation: eventId,
        ticketFormData: ticketFormData,
        defaultPage: "TICKET_BOOKED",
      },
    });
  };

  if (props.auth.loader) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {/* {console.log(ticketFormData)} */}
        <Container fluid className="vendor-orders-request">
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                actionPerform="button"
                backButtonLink={onBackButtonClick}
                displayText="Back"
              />
              <Container fluid>
                <Row className="mb-4">
                  {/* <Col md={12}> */}
                  <EventPaymentMain
                    singleEventData={getSingleEventInfo}
                    ticketData={ticketFormData}
                    eventId={eventId}
                    price={price}
                  />
                  {/* </Col> */}
                  {/* <Col md={4} style={{ backgroundColor: "#ffffff" }}>
                    <RightComponentEventPayment
                      payment={true}
                      singleEventData={getSingleEventInfo}
                      ticketData={ticketFormData}
                    />
                    {/* <RightComponentOrderRequest payment={true} /> *
                  </Col> */}
                </Row>
              </Container>
            </div>
            <div className="bottom-panel"></div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
};

EventPayment.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  get_single_rsvp_event_information: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getSingleEventInfo: state.rsvpEvent.get_single_event_info,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_single_rsvp_event_information,
})(withRouter(EventPayment));
